
import { Options, Vue } from 'vue-class-component';

import VIcon from '@/components/UI/VIcon.vue';

@Options({
  name: 'ShootingPinTableLine',
  components: { VIcon },

  props: {
    panorama: Object,
    active: Boolean,
    index: Number,
    showPlan: Boolean,
    plan: String,
  },
})
export default class ShootingPinTableLine extends Vue {}
